<template>
    <LegalDocument document="terms" />
</template>

<script>
import LegalDocument from './LegalDocument.vue'

export default {
    components: { LegalDocument }
}
</script>
